import React from 'react';
import { connect } from "react-redux";
import './../main.scss'
import './../../main.css'
import { withNamespaces } from 'react-i18next';
import { Row } from 'react-bootstrap';
import { Cell, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';

export class TransactionsByCountry extends React.Component{
    render(){  
        const { t } = this.props

        var colors = ["#1f77b4", "#ff7f0e", "#2ca02c", "red", "#8E30FF", "#99055C","#89B6CF", "#ffa600", "#8b5c14","#656565", "#003f5c", "#f95d6a"];

        const CustomTooltip = ({ active, payload, label }) => {
            if (active && payload && payload.length) {
            return (
                <div className="custom-tooltip">
                <p >{`${label} : ${payload[0].value}`}</p>
                </div>
            );
            }
        
            return null;
        };
      
        return(    
            <Row className="total_users">
                <span className="mb-2"> {t('Amount by payment type')}</span>
                <div className="p-2" id="tabs">
                    <BarChart
                        width={500}
                        height={300}
                        data={this.props.list}
                        margin={{
                            top: 10,
                            right: 30,
                            left: -15,
                            bottom: 5
                        }}
                        >
                        <CartesianGrid strokeDasharray="3 3"/>
                        <XAxis dataKey="paymentType" />
                        <YAxis />
                        <Tooltip content={<CustomTooltip />} />
                        {/* <Bar dataKey="number_of_companies" barSize={20} fill="#0069D3" /> */}
                        <Bar
                            dataKey="count"
                            fill="#00a0fc"
                            stroke="#000000"
                            strokeWidth={1}
                        >
                        {
                            this.props.list.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={colors[index % 20]} />
                            ))
                        }
                    </Bar>
                    </BarChart>
                </div>  
            </Row>
        )
    }  
}

const mapStateToProps = state => {
    return {
        list: state.dashboard.numberOfTransactionsByPaymentType?.map(({ paymentType, amount }) => {
            return {
                paymentType: paymentType,
                count: amount
            }
        }
        )
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
      mapState: (type, data) => dispatch({ type: type, data: data}),
      API: (type, data) => dispatch({ type: type, data: data})
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(TransactionsByCountry));
